import { doPost } from "./api/API";

const reportA2HSInstall = () => {
    let response = doPost('/accounts/report_a2hs_install ', { origin: location.host })
}

export const checkIfShowA2shBtn = (callback) => {
    (window as any).a2hsPromptFunction ?
        callback(true) : setTimeout(() => {
            (window as any).a2hsPromptFunction ?
                callback(true) : setTimeout(() => {
                    (window as any).a2hsPromptFunction ?
                        callback(true) : null;
                }, 3000)
        }, 2000);
}

export const setA2HSTimer = (callback) => {
    callback(false)
    // var currentTime = new Date().getTime();
    // const href = window.location.href;
    // if (href.indexOf('aayu.app') != -1)
    //     var timeout = currentTime + 10 * 60 * 1000
    // else var timeout = currentTime + ShowA2HSTimeout;
    // localStorage.setItem('a2HSTimeout', timeout.toString());
}

export const onPressA2HS = () => {
    if ((window as any)?.a2hsPromptFunction) {
        (window as any).a2hsPromptFunction();
    }
    reportA2HSInstall()
}